<template>
  <sanitas-survey-web :api-base-url="baseDomain" />
</template>

<script>
import SanitasSurveyWeb from 'sanitas-survey-vue2/src/pages/SanitasSurveyWeb'

export default {
  name: 'DotcomSurvey',

  components: {
    SanitasSurveyWeb,
  },
  computed: {
    baseDomain() {
      return process.env.VUE_APP_ROOT_API
    },
  },
}
</script>

